import axios, {AxiosInstance} from "axios";

const apiClient: AxiosInstance = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    headers: {
        "Content-type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        // "Authorization" : `Bearer ${token}`
    },
    timeout: 120000,
});

export default apiClient;
